import { Component, OnInit, Injector, ViewChild } from '@angular/core';
import { GeneralUtils } from 'src/app/shared/utils/general';
import { NgForm } from '@angular/forms';
import { SignInUser } from 'src/app/shared/interfaces/sign-in-user';
import { ExocetService } from 'src/app/shared/services/exocet.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfimationDialogComponent } from 'src/app/shared/components/confimation-dialog/confimation-dialog.component';
import { Recaptcha } from 'src/app/shared/utils/recaptcha';
import { SputnikService } from 'src/app/shared/services/sputnik.service';
import { isEmpty } from 'src/app/shared/utils/validations';
@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent extends GeneralUtils implements OnInit {
    @ViewChild('signInForm') signInForm: NgForm;
    public user: SignInUser = { phone: '', password: '', email: '', referralCode: '' };
    public loginUrl = `${this.environment.CONSTANTS.WEB_PANEL_URL}/panel/login`;
    public repeatPhone = false;
    public loading = false;
    public retailCode;
    public distributorRef = null;

    constructor(
        injector: Injector,
        private exocet: ExocetService,
        private sputnik: SputnikService,
        public dialog: MatDialog
    ) {
        super(injector);
        this.setTitlePage('Registrarse');
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.retailCode = params.retail !== undefined ? params.retail : null;
        });
        this.distributorRef = this.route.snapshot.paramMap.get('distributor') !== null ? this.route.snapshot.paramMap.get('distributor') : null;
    }

    private async signIn(): Promise<void> {
        try {
            this.loader.show();
            const response = await this.exocet.signIn(this.user, await Recaptcha.getToken('signIn'), this.retailCode, this.distributorRef);
            if (response.success) {
                this.router.navigateByUrl(`/onboarding/${response.on_boarding_id}`);
            } else {
                this.snackbar.error(response.error, null, null, { verticalPosition: 'bottom', horizontalPosition: 'center' });
            }
        } catch (error) {
            if (error.status === 422 && error.error.email) {
                this.openConfirmDialog('Correo electrónico ya registrado', 'Este correo electrónico ya ha sido registrado previamente', 'Usar otro correo');
                this.sendEvent(false, 'correoDuplicado');
            } else {
                console.error('Hubo un error al registrarse', error);
                this.snackbar.error('Hubo un error al registrarse, por favor reintente');
            }
        } finally {
            this.loader.hide();
        }
    }

    public async onSubmit(): Promise<void> {
        this.signInForm.control.markAllAsTouched();
        if (this.signInForm.valid) {
            try {
                this.loading = true;
                this.loader.show();
                const { data } = await this.sputnik.checkRepeatedPhone(this.user.phone, await Recaptcha.getToken('checkPhone'));
                if (!data.repeated || this.repeatPhone) {
                    await this.signIn();
                } else {
                    this.openConfirmDialog(
                        'Teléfono utilizado en otra cuenta',
                        'Este teléfono ya ha sido registrado previamente',
                        'Utilizar otra vez',
                        async () => {
                            this.repeatPhone = true;
                            this.sendEvent(false, 'telefonoDuplicado');
                            await this.signIn();
                        }
                    );
                }
            } catch (error) {
                this.snackbar.error(typeof error === 'string' ? error : 'Hubo un error al verificar número teléfono, por favor reintente.');
            } finally {
                this.loading = false;
                this.loader.hide();
            }
        }
    }

    private openConfirmDialog(title: string, message: string, acceptButtonTxt: string, acceptFunction = async () => { }): void {
        this.dialog.open(ConfimationDialogComponent, {
            data: {
                title,
                message,
                cancelButtonTxt: 'Iniciar sesión',
                acceptButtonTxt,
                acceptFunction,
                cancelFuntion: () => {
                    location.href = `${this.loginUrl}${isEmpty(this.user.email) ? '' : `?userEmail=${this.user.email}`}`;
                }
            }
        });
    }

}
